(function ($) {
  videoCategoryRowV1 = {
    formatter: $('.video-category-row-v1')
  };

  Drupal.behaviors.videoCategoryRowV1 = {
    get: function (key) {
      return videoCategoryRowV1[key];
    },

    set: function (key, val) {
      videoCategoryRowV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
        // cached objects
        var heading = thisFormatter.find('.video-category-title');
        var items = thisFormatter.find('.item-video').wrapAll('<div class="items collapsed" />');
        var category = thisFormatter.find('.video-category');
        var container = thisFormatter.find('.items');
        var count = items.length;

        // PC videos
        if ($('body').hasClass('device-pc')) {
        // remove source videos and nodes to speed up loading
          items.find('.item-video-html').remove();
          items.find('.item-video-elc-video').remove();
          items.find('.item-video-node').remove();

          var alias = thisFormatter.attr('path-alias');

          if (alias.length > 0) {
            alias = alias.replace('node/29928', 'this-week-at-clinique');
            items.find('.item-video-thumb img').each(function (i) {
              $(this).wrap('<a href="' + alias + '#' + i + '"></a>');
            });
            items.find('.item-video-title').each(function (i) {
              $(this).wrapInner('<a href="' + alias + '#' + i + '"></a>');
            });
          }
        }

        // Mobile videos
        if ($('body').hasClass('device-mobile')) {
          var videoVideo = thisFormatter.find('.item-video-video');

          // Loop through the video items, get its title and move it after the video HTML div, then remove the original title
          videoVideo.each(function () {
            var videoTitle = $(this).find('.item-video-title'),
              videoHtml = $(this).find('.item-video-html');

            $('<div class="item-video-title">' + videoTitle.text() + '</div>').insertAfter(videoHtml);
            $(this).find('.item-video-title').first().remove();
          });

          // Loop through video categories titles and add "item" attr
          $('.field-mobile-template').find('.video-category-row-v1').find('h3.video-category-title').each(function (i) {
            $(this).attr('item', 'item-' + i);
          });

          // Mobile videos filter
          // Find each hidden video category title
          var videoCatDetailFormatter = thisFormatter.find('.video-category-detail-formatter-v1');

          videoCatDetailFormatter.each(function (i) {
            var self = $(this);
            // Build filters' menu HTML
            var filterHtml = '<section class="videos-filter"><div class="videos-filter-wrapper"><ul class="menu"><li class="first filter-item expanded filter-main"><h2 class="heading"><a href="#">Filter</a><span class="plus"></span></h2><div class="menu-container depth-1"><ul class="menu"><li class="first back"><h2 class="back"><a href="#"><span class="icon"></span><span>Filter</span></a></h2></li></ul></div></li></ul></div></section>';

            // Insert the filters menu before the video container wrapper
            $(filterHtml).insertBefore(thisFormatter.first());

            // Get videos filter section
            var videosFilterSection = $('section.videos-filter');

       	  // Remove extra filters' menus
            thisFormatter.siblings('section.videos-filter').not(videosFilterSection.first()).remove();

            // Find and hide videos filter's depth-1 section
            videosFilterSection.find('.menu-container.depth-1').hide();

            // Retrieve video categories titles div text
            var videoCatTitle = self.find('h3.video-category-title'),
              videoCatTitleText = videoCatTitle.text();
            // Create videoCatTitle and add video cat titles to it
            var videoCatTitle = [];

            videoCatTitle.push(videoCatTitleText);

            // Add the videos cat titles to the list and append it to the depth-1 ul menu
            videosFilterSection.find('.menu-container.depth-1 ul.menu').append('<li class="filter-depth-1-main showMe"><h2 class="heading"><a title="" href="#"><span class="filterby">' + videoCatTitle + '</span></a><span class="close-filter">x</span></h2></li>');

            // Loop through menu items and add "item" attr
            videosFilterSection.find('.menu-container.depth-1 ul.menu li.filter-depth-1-main.showMe h2 a span').each(function (i) {
              $(this).attr('item', 'item-' + i);
            });

            $('.depth-1').find('h2.heading > a').each(function () {
            // Retrieve video categories titles div text
              var videoCatTitle = self.find('h3.video-category-title'),
                videoCatTitleText = videoCatTitle.text();
              var trimmedVideoCatTitle = videoCatTitleText.toLowerCase().replace(/[^A-Za-z0-9_]/g, ' ');
              // trimmedVideoCatTitle = trimmedVideoCatTitle.substring(0, trimmedVideoCatTitle.length - 4);
              // console.log( 'trimmedVideoCatTitle: ' + trimmedVideoCatTitle + ' - videoCatTitleText: ' + videoCatTitleText );
              // Assign "this" to "a" to avoid confusion with "this"
              var a = $(this);

              a.on('click', function(e) {
              // Check if there is any available link URL and if not (href equals 1) prevent default behavior
                if ($(this).attr('href').length === 1) {
                  e.preventDefault();
                  e.stopPropagation();
                }

                // Add / remove the "x"
                a.toggleClass('active');

                // Add/remove "selected" class on click to change parent (li) background color
                a.parent().parent().toggleClass('selected');

                // Replace "Filter" text with "this" selected filter text
                a.parent().parent().parent().parent().parent().find('h2.heading > a').first().text('Filtered by ' + a.text());

                // Get videos filter section
                // var videosFilterSection = $("section.videos-filter");

                // Find and hide videos filter's depth-1 section
                // videosFilterSection.find('.menu-container.depth-1').hide();

                // Loop through video categories titles
                var item = a.children().attr('item');
                var videoItem = self.find('h3.video-category-title').attr('item');

                videoCatTitle.next().filter(function () {
                  console.log('Equals - videoItem: ' + videoItem + ' - item: ' + item);

                  return videoItem === item;
                }).toggle();
              });
            });
          });

          // Mobile videos filters' navigation menu
          $('.videos-filter > .videos-filter-wrapper > ul.menu > li > h2 > a').each(function () {
            $(this).on('click', function(e) {
            // Check if there is any available link URL and if not (href equals 1) prevent default behavior
              if ($(this).attr('href').length === 1) {
                e.preventDefault();
              }

              // First value for left offset, second value for top offset
              window.scrollTo(-100, 0);

              // Slide to the left and hide main filters menu
              $('.videos-filter').animate({
                left: '-100%',
                scrollTop: $('body').offset().top
              }, { duration: 500 });

              // Reset left margin and show depth-1 items
              $('.menu-container.depth-1').css({ 'margin-left': '0' }).show();

              // Hide all filters main menu
              $(this).parent().hide();

              // Show back button
              $(this).parent().next().first().children().find('h2.back').show();

              // Populate the back link with its parent menu item text
              $(this).parent().parent().next().first().children().find('h2.back span:last').first().text($(this).text());
            });
          });

          // Back to the filters main menu
          $('.depth-1').find('h2.back > a').each(function () {
            $(this).on('click', function(e) {
              e.preventDefault();

              // First value for left offset, second value for top offset
              window.scrollTo(-100, 0);

              // Show main mobile videos filter menu
              $('.videos-filter').animate({
                left: '0',
                scrollTop: $('body').offset().top
              }, { duration: 10 });

              // Show main menu items
              $('.videos-filter li.filter-main').find('h2.heading').show();

              // Hide cats menu wrapper
              $('.menu-container.depth-1').hide();
            });
          });
        } // end if device-mobile

        // append (count) to h3
        if (heading.length == 1) {
          if (count > 0 && count !== null) {
            heading.append(' <span class="item-count">(' + count + ')</span>');
          }
        }

        // PC: add .last-item to every 3rd item
        if ($('body').hasClass('device-pc')) {
          items.filter(':nth-child(3n)').addClass('last-item');
        }

        // Default minimun video items count in a row for PC
        // Show "toggle" button if there are more than 3
        var videoItemsCount = 3;

        // Default minimun video items count in a row for mobile
        // Show "toggle" button if there are more than 2
        if ($('body').hasClass('device-mobile')) {
          videoItemsCount = 2;
          // add .last-item to every 2nd item
          items.filter(':nth-child(2n)').addClass('last-item');
        }

        // add expand/collapse functionality
        if (count > videoItemsCount && count !== null) {
          var toggle = $('<div class="expand-toggle closed"></div>');

          category.prepend(toggle);
          toggle.once('template-expand-toggle').on('click', function() {
            var categoryOffsetTop = $(this).closest('.row').offset().top;

            container.toggleClass('collapsed');
            $(this).toggleClass('closed');
            if (!container.hasClass('collapsed')) {
              $('html, body').delay(500).animate({
                scrollTop: categoryOffsetTop - 47
              }, 500);
            }
          });
        }

        $('.item-video-video', thisFormatter).addClass('active');
        $('.item-video-thumb', thisFormatter).addClass('active');
      });
    }
  };
})(jQuery);
